/*global Modernizr, lottie, location_atm_list, location_branch_list */
/*jslint browser:true */

(function() {
  'use strict';

  var locations_search_list = document.getElementById('locations-search-list');
  if(locations_search_list) {
    var location_grid = locations_search_list.querySelector('.location-grid');

    locations_search_list.addEventListener('load-locations', (e) => {
      location_grid.innerHTML = '';

      e.detail.locations.forEach((location) => {
        if(location.type === 'atm') {
          location_grid.insertAdjacentHTML( 'beforeend', location_atm_list(location) );
        } else {
          if(!location.is_closed) {
            location.closed = ' hidden';
          } else {
            location.closed = '';
          }

          var block = location_branch_list(location);

          if(location['drive_thru_hours'] === '') {
            block = block.replace('<div class="h6">Drive-Thru Hours</div><p></p>', '');
          }

          location_grid.insertAdjacentHTML('beforeend', block);
        }
      });
    });
  }
}());